import { render, staticRenderFns } from "./BeltSVG.vue?vue&type=template&id=4f0886c6"
import script from "./BeltSVG.vue?vue&type=script&lang=js"
export * from "./BeltSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports